<div
  class="pho-sidebar {{ styleClass }}"
  [ngClass]="sidebarCollapse ? 'sidebar-collapse' : ''"
>
  <p-overlayPanel
    #experimentDetailsOp
    styleClass="exp-details-tooltip-panel"
    appendTo="body"
    [dismissable]="false"
  >
    <ng-template pTemplate>
      <div
        class="exp-details-tooltip"
        *ngIf="experimentData?.name"
        (mouseenter)="cancelHideExperimentTooltip()"
        (mouseleave)="hideExperimentTooltip(experimentDetailsOp)"
        (focusin)="cancelHideExperimentTooltip()"
        (focusout)="hideExperimentTooltip(experimentDetailsOp)"
      >
        <div class="exp-tooltip-name">
          <span>{{ experimentData?.name }}</span>
          <button
            type="button"
            class="exp-tooltip-copy"
            [attr.aria-label]="'Copy experiment name: ' + experimentData?.name"
            (click)="copyExperimentName($event)"
          >
            <img
              [src]="
                copiedExperimentName
                  ? '/assets/images/tick-green.svg'
                  : '/assets/images/copy.svg'
              "
              alt=""
            />
          </button>
        </div>

        <div class="exp-tooltip-meta">
          <div *ngIf="experimentData?.key_accound">
            <span>Key Account</span>
            <strong>{{ experimentData?.key_accound }}</strong>
          </div>
          <div *ngIf="experimentData?.country">
            <span>Country</span>
            <strong>{{ experimentData?.country }}</strong>
          </div>
          <div *ngIf="experimentData?.category">
            <span>Category</span>
            <strong>{{ experimentData?.category }}</strong>
          </div>
          <div *ngIf="experimentData?.region">
            <span>Region</span>
            <strong>{{ experimentData?.region }}</strong>
          </div>
        </div>
      </div>
    </ng-template>
  </p-overlayPanel>

  <div
    class="icon-menu flex items-center justify-center"
    *ngIf="sidebarCollapse"
    (click)="checkSidebarActive()"
  >
    <img src="/assets/images/icon-menu-burger.svg" />
  </div>

  <div
    class="flex items-center justify-content-between experiment-block m-0 p-3"
    *ngIf="!sidebarCollapse"
  >
    <div
      class="exp-details exp-details-tooltip-host flex-initial w-4/4"
      [attr.tabindex]="experimentData?.name ? 0 : null"
      (mouseenter)="showExperimentTooltip($event, experimentDetailsOp)"
      (mouseleave)="hideExperimentTooltip(experimentDetailsOp)"
      (focus)="showExperimentTooltip($event, experimentDetailsOp)"
      (blur)="hideExperimentTooltip(experimentDetailsOp)"
    >
      <p-skeleton
        width="7rem"
        height="1rem"
        styleClass="head-h4 mb-2"
        *ngIf="experimentDetails?.length === 0"
      ></p-skeleton>

      <div class="flex">
        <p-skeleton
          width="2.5rem"
          height="1rem"
          styleClass="head-h5 mr-2"
          *ngIf="experimentDetails?.length === 0"
        ></p-skeleton>

        <p-skeleton
          width="2.5rem"
          height="1rem"
          styleClass="head-h5 mr-2"
          *ngIf="experimentDetails?.length === 0"
        ></p-skeleton>

        <p-skeleton
          width="2.5rem"
          height="1rem"
          styleClass="head-h5"
          *ngIf="experimentDetails?.length === 0"
        ></p-skeleton>
      </div>

      <ng-container *ngIf="experimentData">
        <p class="pt-1 head-h4 break-anywhere">{{ experimentData?.name }}</p>

        <span class="head-h5">{{ experimentData?.key_accound }}</span>
        <span class="head-h5">{{ experimentData?.country }}</span>
        <span class="head-h5" *ngIf="experimentData?.category">{{
          experimentData?.category
        }}</span>
        <span class="head-h5 last-child">{{ experimentData?.region }}</span>
      </ng-container>
    </div>
    <div
      class="flex justify-end items-center p-0"
      *ngIf="experimentData?.name && editAccessType"
    >
      <!-- <app-edit-btn
        [disabledFlag]="true"
        (actionBtnCallback)="navigateToEdit()"
      ></app-edit-btn> -->
    </div>
  </div>

  <div class="experiment-name-out" *ngIf="sidebarCollapse">
    <div class="experiment-name">
      {{ exprimentName }}

      <!-- <div
        class="edit-icon disabled"
        (click)="navigateToEdit()"
        *ngIf="editAccessType"
      >
        <img src="/assets/images/icon-pencil-black.svg" />
      </div> -->
    </div>

    <div class="experiment-block m-0 py-2 px-3">
      <div
        class="exp-details exp-details-tooltip-host"
        [attr.tabindex]="experimentData?.name ? 0 : null"
        (mouseenter)="showExperimentTooltip($event, experimentDetailsOp)"
        (mouseleave)="hideExperimentTooltip(experimentDetailsOp)"
        (focus)="showExperimentTooltip($event, experimentDetailsOp)"
        (blur)="hideExperimentTooltip(experimentDetailsOp)"
      >
        <ng-container *ngIf="experimentData">
          <p
            class="pt-1 head-h4 break-anywhere"
            title="{{ experimentData?.name }}"
          >
            {{ experimentData?.name }}
          </p>

          <span class="head-h5">{{ experimentData?.key_accound }}</span>
          <span class="head-h5">{{ experimentData?.country }}</span>
          <span class="head-h5 last-child">{{ experimentData?.region }}</span>
        </ng-container>
      </div>
    </div>
  </div>

  <div
    *ngIf="visibleSteps.length > 0"
    class="menu-item-out"
    (mouseleave)="sidebarCollapse ? hideMenuItems('planDetails') : ''"
  >
    <p
      *ngIf="!fromAssortment"
      class="head-h3 head-icon flex items-center"
      [ngClass]="sidebarCollapse && planDetails.dropShow ? 'active' : ''"
      (mouseenter)="sidebarCollapse ? showMenuItems('planDetails') : ''"
    >
      <img src="/assets/images/{{ planDetails.icon }}" />
      <span class="ml-3" *ngIf="!sidebarCollapse">{{ planDetails.name }}</span>
    </p>
    <div
      [ngClass]="sidebarCollapse ? 'drop-down' : ''"
      *ngIf="sidebarCollapse ? planDetails.dropShow : true"
    >
      <p class="head-h3" *ngIf="sidebarCollapse && !fromAssortment">
        {{ planDetails.name }}
      </p>
      <ul class="pho-plan">
        <li
          *ngFor="let step of visibleSteps; let i = index"
          [ngClass]="{
            'drop-item': step?.sub_level,
            'drop-expanded': step?.sub_menu_show,
          }"
        >
          <div
            class="w-100 step_{{
              step.status
            }} relative list-none head-h4 nav-item flex items-center justify-between"
            [ngClass]="{
              'is-active': step.slug === level,
              'opacity-50 cursor-not-allowed': step.disabled,
              previousStepCompleted:
                visibleSteps[i - 1]?.status === 'completed' && !readOnly,
            }"
            (click)="
              !step.disabled &&
              (step.status === 'completed' ||
                step.status === 'in_progress' ||
                (visibleSteps[i - 1]?.status === 'completed' && !readOnly) ||
                step?.sub_level)
                ? navigateToStep(step)
                : ''
            "
          >
            <span class="d-flex">
              <p class="flex items-center w-9">
                <ng-container *ngIf="!step?.sub_menu_show">
                  <span
                    *ngIf="step.status === 'completed' && !lockAssortment"
                    class="tick-icon"
                  >
                    <app-svg-icon
                      icon="tick-icon"
                      color="#000"
                      padding="6px"
                    ></app-svg-icon>
                  </span>
                  <span
                    *ngIf="step.status !== 'completed' && !lockAssortment"
                    class="h-5 mr-4"
                  >
                    <app-svg-icon
                      icon="inprogress"
                      color="#e4bf00"
                      padding="9.5px"
                    ></app-svg-icon>
                  </span>
                  <span *ngIf="lockAssortment" class="h-5 mr-4">
                    <app-svg-icon
                      icon="lock-icon"
                      color="#e4bf00"
                      padding="9.5px"
                    ></app-svg-icon>
                  </span>
                </ng-container>
              </p>
              <p class="step-label">{{ step.label }}</p>
            </span>

            <span class="pr-4">
              <img
                *ngIf="step?.sub_level && !step?.sub_menu_show"
                src="/assets/images/{{
                  ['completed', 'in_progress'].includes(step.status)
                    ? 'arrow-yellow-down.svg'
                    : 'arrow-gray-down.svg'
                }}"
              />

              <img
                *ngIf="step?.sub_level && step?.sub_menu_show"
                src="/assets/images/{{
                  ['completed', 'in_progress'].includes(step.status)
                    ? 'arrow-yellow-up.svg'
                    : 'arrow-gray-up.svg'
                }}"
              />
            </span>
          </div>

          <ul
            *ngIf="step?.sub_level && step?.sub_menu_show"
            class="sub-menu sub_{{ step.status }}"
          >
            <li
              *ngFor="let subLevel of step?.sub_level"
              class="step_{{
                subLevel.status
              }} relative list-none head-h4 nav-item"
              [ngClass]="{
                'is-active': subLevel.slug === level,
              }"
              (click)="
                subLevel.status === 'completed' ||
                subLevel.status === 'in_progress'
                  ? navigateToStep(subLevel)
                  : ''
              "
            >
              <div>
                <span class="d-flex">
                  <p class="flex items-center">
                    <span
                      [ngClass]="
                        subLevel.status === 'completed' && !lockAssortment
                          ? 'tick-icon'
                          : 'h-5 mr-4'
                      "
                    >
                      <app-svg-icon
                        *ngIf="!lockAssortment"
                        [icon]="
                          subLevel.status === 'completed'
                            ? 'tick-icon'
                            : 'inprogress'
                        "
                        [color]="
                          subLevel.status === 'completed' ? '#000' : '#e4bf00'
                        "
                        [padding]="
                          subLevel.status === 'completed' ? '6px' : '9.5px'
                        "
                      ></app-svg-icon>

                      <app-svg-icon
                        *ngIf="lockAssortment"
                        icon="lock-icon"
                        color="#e4bf00"
                        padding="9.5px"
                      ></app-svg-icon>
                    </span>
                  </p>
                  <p class="step-label">
                    {{ subLevel.label }}
                  </p>
                </span>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>

  <!-- Space Secondary Menu -->
  <ng-container *ngIf="isSpaceSidebarEnable()">
    <div
      class="menu-item-out"
      (mouseleave)="sidebarCollapse ? hideMenuItems('spaceDetails') : ''"
    >
      <p
        class="head-h3 head-icon flex items-center"
        [ngClass]="getDynamicClasses()"
        (mouseenter)="sidebarCollapse ? showMenuItems('spaceDetails') : ''"
        (click)="spaceDetails.navigateRoute && navigateToRoute()"
      >
        <img src="/assets/images/{{ spaceDetails.icon }}" />
        <span class="ml-3" *ngIf="!sidebarCollapse">{{
          spaceDetails.name
        }}</span>
      </p>
      <div
        [ngClass]="sidebarCollapse ? 'drop-down' : ''"
        *ngIf="sidebarCollapse ? spaceDetails.dropShow : true"
      >
        <p
          class="head-h3"
          [ngClass]="getDynamicClasses()"
          *ngIf="sidebarCollapse"
          (click)="spaceDetails.navigateRoute && navigateToRoute()"
        >
          {{ spaceDetails.name }}
        </p>
        <ul class="exe-summary" *ngIf="spaceSteps.length > 0">
          <li
            *ngFor="let step of spaceSteps; let i = index"
            class="step_{{ step.status }} head-h4 nav-item"
            (click)="navigateToStep(step)"
            [ngClass]="{
              'is-active': step?.slug_group?.includes(level),
            }"
          >
            <span class="d-flex">
              <p class="step-label">{{ step.label }}</p>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </ng-container>

  <div class="btn-arrow-expand" (click)="checkSidebarActive()">
    <span *ngIf="!sidebarCollapse"
      ><img src="/assets/images/icon-arrow-collapse.svg"
    /></span>
    <span *ngIf="sidebarCollapse"
      ><img src="/assets/images/icon-arrow-collapse.svg"
    /></span>
  </div>
</div>
